import { Filter } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/Select';

interface TaxonomyFiltersProps {
  filters: {
    selectedCategory: string;
    group: string | null;
    groupName: string | null;
    property: string | null;
  };
  setFilters: React.Dispatch<
    React.SetStateAction<{
      selectedCategory: string;
      group: string | null;
      groupName: string | null;
      property: string | null;
    }>
  >;
  categories: string[];
  uniqueValues: {
    groups: string[];
    groupNames: string[];
    properties: string[];
  };
}

export function TaxonomyFilters({
  filters,
  setFilters,
  categories,
  uniqueValues,
}: TaxonomyFiltersProps) {
  const activeFilterCount = [
    filters.group,
    filters.groupName,
    filters.property,
  ].filter(Boolean).length;

  function clearFilters() {
    setFilters((prev) => ({
      ...prev,
      group: null,
      groupName: null,
      property: null,
    }));
  }

  return (
    <div className="mb-4 flex flex-wrap gap-2">
      <Select
        value={filters.selectedCategory ?? ''}
        onValueChange={(value) =>
          setFilters((prev) => ({ ...prev, selectedCategory: value }))
        }
      >
        <SelectTrigger id="category" className="w-[200px] gap-1 bg-white">
          <Filter className="h-4 w-4" />
          <SelectValue placeholder="Category" />
        </SelectTrigger>

        <SelectContent>
          {categories.map((category) => (
            <SelectItem key={category} value={category}>
              {category}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.group ?? ''}
        onValueChange={(value) =>
          setFilters((prev) => ({ ...prev, group: value }))
        }
      >
        <SelectTrigger className="w-[200px] bg-white">
          <Filter className="h-4 w-4" />
          <SelectValue placeholder="Group" />
        </SelectTrigger>

        <SelectContent>
          {uniqueValues.groups.map((value) => (
            <SelectItem key={value} value={value}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.groupName ?? ''}
        onValueChange={(value) =>
          setFilters((prev) => ({ ...prev, groupName: value }))
        }
      >
        <SelectTrigger className="w-[200px] bg-white">
          <Filter className="h-4 w-4" />
          <SelectValue placeholder="Group Name" />
        </SelectTrigger>

        <SelectContent>
          {uniqueValues.groupNames.map((value) => (
            <SelectItem key={value} value={value}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Select
        value={filters.property ?? ''}
        onValueChange={(value) =>
          setFilters((prev) => ({ ...prev, property: value }))
        }
      >
        <SelectTrigger className="w-[200px] bg-white">
          <Filter className="h-4 w-4" />
          <SelectValue placeholder="Property" />
        </SelectTrigger>

        <SelectContent>
          {uniqueValues.properties.map((value) => (
            <SelectItem key={value} value={value}>
              {value}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {activeFilterCount > 0 && (
        <Button variant="outline" onClick={clearFilters}>
          Clear Filters ({activeFilterCount})
        </Button>
      )}
    </div>
  );
}
